module.exports = __webpack_public_path__ + "img/idle-dj-details7.e380bf60.png";